import { Link, Outlet } from "react-router";
import { Button } from "@electro-planner/ui";
import { authClient } from "../lib/auth.ts";

export function Shell() {
  const { data: session } = authClient.useSession();

  return (
    <div className="flex min-h-full flex-col">
      <header className="flex items-center justify-between border-b border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-2">
        <Link to="/" className="font-semibold">
          electro-planner
        </Link>
        <div className="flex items-center gap-3 text-sm">
          <span className="text-[var(--color-muted)]">
            {session?.user?.email ?? ""}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              void authClient.signOut().then(() => {
                window.location.assign("/login");
              });
            }}
          >
            Logga ut
          </Button>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
